module.exports = __webpack_public_path__ + "static/media/pbis_reward.40bf3d93.svg";